const state = {
  token: '',
  id: '',
  nickname: '',
  avatar: ''
};

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.token = userInfo.token;
    state.id = userInfo.id;
    state.nickname = userInfo.nickname;
    state.avatar = userInfo.avatar;
  },
  CLEAR_USER_INFO(state) {
    state.token = '';
    state.id = '';
    state.nickname = '';
    state.avatar = '';
  }
};

const actions = {
  setUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo);
  },
  clearUserInfo({ commit }) {
    commit('CLEAR_USER_INFO');
  }
};

const getters = {
  isLoggedIn: state => !!state.token,
  userNickname: state => state.nickname,
  userAvatar: state => state.avatar
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js